// extracted by mini-css-extract-plugin
module.exports = {"arrowContainer":"Carousel_arrowContainer__J6i2m","hiddenArrowContainer":"Carousel_hiddenArrowContainer__1kh0x"};